import { useContentResource, useImageResource } from "@ctv/core";
import { TextSeo, ViewSeo } from "@ctv/shared-core/src";

import FeatureItem from "./FeatureItem";
import cssStyles from "./FeaturesList.module.css";

export default function FeaturesList() {
  const cr = useContentResource().CorporateRevampFeaturesPage;
  const images = useImageResource().CorporateRevampFeaturesPage;
  const accessRoleContents = [
    { title: cr.userAccessSubtitle1, content: cr.userAccessContent1 },
    { title: cr.userAccessSubtitle2, content: cr.userAccessContent2 },
  ];
  const approvalSystemContents = [
    { title: cr.approvalSystemSubtitle1, content: cr.approvalSystemContent1 },
    { title: cr.approvalSystemSubtitle2, content: cr.approvalSystemContent2 },
    { title: cr.approvalSystemSubtitle3, content: cr.approvalSystemContent3 },
  ];
  const travelPolicyContents = [
    { title: cr.travelPolicySubtitle1, content: cr.travelPolicyContent1 },
    { title: cr.travelPolicySubtitle2, content: cr.travelPolicyContent2 },
  ];
  const invoiceReportContents = [
    { title: cr.invoiceReportSubtitle1, content: cr.invoiceReportContent1 },
    { title: cr.invoiceReportSubtitle2, content: cr.invoiceReportContent2 },
  ];

  return (
    <ViewSeo className={cssStyles.container}>
      <TextSeo
        variant="ui-large-bold"
        ink="black-primary"
        className={cssStyles.highlight}
      >
        {cr.highlightText}
      </TextSeo>
      <ViewSeo spacing="xxxxl">
        <FeatureItem
          imageUrl={images.userAccessRole.link}
          title={cr.userAccessTitle}
          contents={accessRoleContents}
        />
        <FeatureItem
          imageUrl={images.approvalSystem.link}
          title={cr.approvalSystemTitle}
          contents={approvalSystemContents}
          reverse
        />
        <FeatureItem
          imageUrl={images.travelPolicy.link}
          title={cr.travelPolicyTitle}
          contents={travelPolicyContents}
        />
        <FeatureItem
          imageUrl={images.invoiceReport.link}
          title={cr.invoiceReportTitle}
          contents={invoiceReportContents}
          reverse
        />
      </ViewSeo>
    </ViewSeo>
  );
}
